import React, { useState } from "react";

export default function FAQ() {
  // State to manage open/closed sections
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    // Toggle section by setting it to either the section number or null if it's already open
    setOpenSection(openSection === section ? null : section);
  };
  return (
    <section class="py-24">
      <div class="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8">
        <div class="mb-16">
          <h2 class="text-4xl font-manrope text-center font-bold text-gray-900 leading-[3.25rem]">
            Frequently asked questions
          </h2>
        </div>
        <div
          className="md:w-full overflow-hidden"
          data-accordion="default-accordion"
        >
          <div
            className={`accordion border border-solid border-gray-300 p-4 w-full md:w-[62rem] rounded-xl transition duration-500 ${
              openSection === 1
                ? "accordion-active:bg-neutral-100 accordion-active:border-black"
                : ""
            } mb-8 lg:p-4`}
            id="basic-heading-one-with-icon"
          >
            <button
              className="accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-black"
              onClick={() => toggleSection(1)}
              aria-controls="basic-collapse-one-with-icon"
            >
              <h5>What languages are supported?</h5>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 1 ? "hidden" : "block"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18M12 18V6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 1 ? "block" : "hidden"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div
              id="basic-collapse-one-with-icon"
              className={`accordion-content w-full overflow-hidden pr-4 transition duration-500 ${
                openSection === 1 ? "block" : "hidden"
              }`}
              aria-labelledby="basic-heading-one"
            >
              <p class="text-base text-gray-900 font-normal leading-6">
                As of now, English, French, and Spanish are supported. We are
                working on adding more languages in the future.
              </p>
            </div>
          </div>

          <div
            className={`accordion border border-solid border-gray-300 p-4  w-full md:w-[62rem] rounded-xl transition duration-500 ${
              openSection === 2
                ? "accordion-active:bg-neutral-100 accordion-active:border-black"
                : ""
            } mb-8 lg:p-4`}
            id="basic-heading-one-with-icon"
          >
            <button
              className="accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-black"
              onClick={() => toggleSection(2)}
              aria-controls="basic-collapse-one-with-icon"
            >
              <h5>What kind of videos are supported?</h5>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 2 ? "hidden" : "block"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18M12 18V6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 2 ? "block" : "hidden"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div
              id="basic-collapse-one-with-icon"
              className={`accordion-content w-full overflow-hidden pr-4 transition duration-500 ${
                openSection === 2 ? "block" : "hidden"
              }`}
              aria-labelledby="basic-heading-one"
            >
              <p class="text-base text-gray-900 font-normal leading-6">
                Zen-Stream supports a wide range of video formats, including
                MP4, AVI, MOV, WMV, and more. We also support audio files in
                MP3, WAV, and other formats. However, as the algorithm solely
                relies on speech, we recommend using video files with clear
                audio.
              </p>
            </div>
          </div>

          <div
            className={`accordion border border-solid border-gray-300 p-4 rounded-xl  w-full md:w-[62rem] transition duration-500 ${
              openSection === 3
                ? "accordion-active:bg-neutral-100 accordion-active:border-black"
                : ""
            } mb-8 lg:p-4`}
            id="basic-heading-one-with-icon"
          >
            <button
              className="accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-black"
              onClick={() => toggleSection(3)}
              aria-controls="basic-collapse-one-with-icon"
            >
              <h5>Is Zen-Stream Free?</h5>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 3 ? "hidden" : "block"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18M12 18V6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 3 ? "block" : "hidden"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div
              id="basic-collapse-one-with-icon"
              className={`accordion-content w-full overflow-hidden pr-4 transition duration-500 ${
                openSection === 3 ? "block" : "hidden"
              }`}
              aria-labelledby="basic-heading-one"
            >
              <p class="text-base text-gray-900 font-normal leading-6">
                We offer one free video a month. After that, you can choose to
                upgrade to Zen-Stream Starter for $10 per month.
              </p>
            </div>
          </div>

          <div
            className={`accordion border border-solid border-gray-300 p-4  w-full md:w-[62rem] rounded-xl transition duration-500 ${
              openSection === 4
                ? "accordion-active:bg-neutral-100 accordion-active:border-black"
                : ""
            } mb-8 lg:p-4`}
            id="basic-heading-one-with-icon"
          >
            <button
              className="accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-black"
              onClick={() => toggleSection(4)}
              aria-controls="basic-collapse-one-with-icon"
            >
              <h5>I have more questions. How can I contact your team?</h5>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 4 ? "hidden" : "block"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18M12 18V6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <svg
                className={`w-6 h-6 text-gray-900 transition duration-500 ${
                  openSection === 4 ? "block" : "hidden"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div
              id="basic-collapse-one-with-icon"
              className={`accordion-content w-full overflow-hidden pr-4 transition duration-500 ${
                openSection === 4 ? "block" : "hidden"
              }`}
              aria-labelledby="basic-heading-one"
            >
              <p class="text-base text-gray-900 font-normal leading-6">
                Feel free to contact us by email at team@zenstream.app
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
